import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import RegulationModal from './RegulationsModal'
import Clients from 'redux/clients'

class RegulationsModalContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showTerms: false,
      regulationsArray: [],
      content: '',
      idRegulation: 14,
      isCompleted: false,
      isLoading: false
    }
  }

  componentDidMount () {
    this.getTermsAccepted()
  }

  componentDidUpdate (prev) {
    let LGPDAtual = this.props.regulationsModal.regulations
    if (LGPDAtual !== prev.regulationsModal.regulations) {
      this.getTermsAccepted()
    }
  }

  getTermsAccepted () {
    let allRegulations = this.props.regulationsModal.regulations
    if (this.state.regulationsArray.length === 0 && !this.state.isCompleted) {
      allRegulations.forEach(item => {
        this.state.regulationsArray.push(item)
      })
    }
    if (this.state.regulationsArray.length > 0) {
      let currentRegulation = this.state.regulationsArray[0]
      this.setState({ content: currentRegulation.html })
      this.setState({ idRegulation: currentRegulation.id })
      this.setState({ showTerms: true })
    }
  }

  async onAcceptTerms () {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true })
      await Clients.cloudloyalty.client.put(
        `v1/participants/regulations/accept/${this.state.idRegulation}`,
        null
      )
      this.setState({ showTerms: false })
      this.setState({ isLoading: false })
      this.state.regulationsArray = this.state.regulationsArray.filter(item => {
        return item.id !== this.state.idRegulation
      })
      if (this.state.regulationsArray.length > 0) {
        this.getTermsAccepted()
      } else {
        this.setState({ idCompleted: true })
      }
    }
  }

  onCloseModal () {
    this.setState({ showTerms: false })
  }

  render () {
    return (
      <RegulationModal
        showTerms={this.state.showTerms}
        acceptTerms={e => this.onAcceptTerms()}
        content={this.state.content}
        isLoading={this.state.isLoading}
      />
    )
  }
}

const mapStateToProps = ({ regulationsModal }) => ({
  regulationsModal: regulationsModal
})

RegulationsModalContainer.propTypes = {
  regulationsModal: PropTypes.object
}

export default connect(mapStateToProps)(RegulationsModalContainer)



// WEBPACK FOOTER //
// ./src/features/RegulationModal/RegulationsModalContainer.js